// actions/createRecordSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const createRecord = createAsyncThunk(
  'contact/createRecord',
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        'https://etrg2bri6c.execute-api.us-east-1.amazonaws.com/sqa/create-record',
        {
          record_type: 'Contact_Us',
          record_value: formData,
        },
        {
          headers: {
            'Content-Type': 'application/json'
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const createRecordSlice = createSlice({
  name: 'contact',
  initialState: {
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createRecord.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createRecord.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(createRecord.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default createRecordSlice.reducer;